import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_intimates: FaireCategoryEntity = {
  token: "cat_women-intimates",
  type: "category",
  name: "Intimates & shapewear",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/intimates",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
